import { useQuery } from '@tanstack/react-query';
import { speakersApi } from '../api/speakersApi';
import type { SpeakersResponse } from '../types/speaker.types';

/**
 * Hook to fetch speakers for an event
 * 
 * @param eventSlug - The event slug to fetch speakers for
 */
export const useSpeakers = (eventSlug: string) => {
  return useQuery<SpeakersResponse>({
    queryKey: ['speakers', eventSlug],
    queryFn: () => speakersApi.getSpeakers(eventSlug),
    staleTime: 10 * 60 * 1000, // Consider data fresh for 10 minutes
    enabled: !!eventSlug
  });
};